import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-terminos-component',
  templateUrl: './terminos.component.html',
  styleUrls: ['./terminos.component.scss'],
})
export class TerminosComponent implements OnInit {
  @Input() pathJSON: string;
   terminos: any[];
   automaticClose = false;
   public json: string;

  constructor(
    private httpClient: HttpClient
  ) {}

  ngOnInit() {
    // console.log('objecuikuikuilt');
    // console.log('object', this.pathJSON);
    if (!this.pathJSON) {
      this.pathJSON = 'terminos.json';
    }
    this.httpClient.get('../../assets/' + this.pathJSON).subscribe(res => {
      // tslint:disable-next-line:no-string-literal
      this.terminos = res['terminos'];
    });
  }

toggleSelection(index) {
  this.terminos[index].open = !this.terminos[index].open;
  if (this.automaticClose && this.terminos[index].open) {
    // console.log('iffff', this.automaticClose);
    this.terminos.filter((item, itemIndex) => itemIndex !== index)
          .map(item => {
            // console.log('item', item);
            item.open = false
          });
  }
}

toggleCollapse() {
  // console.log('this.automaticClose');
  this.automaticClose = !this.automaticClose;
  this.terminos.forEach(item => { item.open = this.automaticClose});
}

}


























